// ページトップボタンの表示 // Display the page top button
jQuery(function ($) {

	if ($('#pageup').length > 0) {
		var topBtn = $('#pageup');

		//スクロールしてトップ // scroll to the top
		topBtn.click(function () {
			$('body,html').animate({
				scrollTop: 0
			}, 500);
			return false;
		});
	}
});